// extracted by mini-css-extract-plugin
export var btnContent = "index-module--btnContent--cbtu9";
export var certificationType = "index-module--certificationType--Rl66M";
export var imgContent = "index-module--imgContent--PbCRg";
export var inner = "index-module--inner--V8EKy";